import { Button } from "../Button";

export const EmptyBusinessSkeleton = () => {
  return (
    <div className="max-w-lg">
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>
          <div className="mt-2 sm:flex sm:items-start sm:justify-between">
            <div className="max-w-xl text-sm text-gray-500">
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
            <div className="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
              <Button disabled type="button" loading={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
